import ModalDesktop from './modal-desktop';

export default ModalDesktop;
